module.exports = __webpack_public_path__ + "img/10mmluoding.prt.16049b3f.jpg";